import { useNavigate } from "react-router-dom";
import { ArrowRight, CreditCard, ShieldCheck, Wallet, Zap } from "lucide-react";
import { Header, Ticker } from "@/components/Header";
import { PriceChart } from "@/components/PriceChart";
import { useAuth } from "@/context/AuthContext";

const FEATURES = [
  { icon: CreditCard, t: "Pay by card", d: "Visa, Mastercard and more through Stripe's secure checkout." },
  { icon: Zap, t: "Instant settlement", d: "BTC lands in your Bitwallet.live wallet the moment payment clears." },
  { icon: Wallet, t: "Sell anytime", d: "Convert BTC back to USD at the live rate, credited instantly." },
];

export default function Landing() {
  const { user, login } = useAuth();
  const nav = useNavigate();
  return (
    <div className="grain min-h-screen bg-[#08090E]">
      <Header />
      <main className="relative z-10 mx-auto max-w-7xl px-4 pb-24 pt-32 md:px-8 md:pt-40">
        <div className="grid items-center gap-12 lg:grid-cols-12">
          <div className="fade-up lg:col-span-6">
            <p className="mb-6 text-xs font-semibold uppercase tracking-[0.2em] text-[#F7931A]">Live Kraken pricing · 1% flat fee</p>
            <h1 className="text-4xl font-bold leading-[1.05] tracking-tighter sm:text-5xl lg:text-6xl">
              Buy & sell Bitcoin<br /><span className="text-[#F7931A]">with your credit card.</span>
            </h1>
            <p className="mt-6 max-w-lg text-base text-[#94A3B8] md:text-lg">
              Direct platform execution at live market prices. Instant settlement to your Bitwallet.live wallet.
            </p>
            <div className="mt-10 flex flex-wrap gap-3">
              <button onClick={() => (user ? nav("/dashboard") : login())} data-testid="hero-get-started-button"
                className="group flex items-center gap-2 rounded-full bg-[#F7931A] px-7 py-3.5 font-semibold text-[#08090E] transition-transform hover:scale-[1.03] hover:bg-amber-500">
                {user ? "Open dashboard" : "Get started with Google"} <ArrowRight size={18} className="transition-transform group-hover:translate-x-1" />
              </button>
              <a href="#market" data-testid="hero-view-market-link" className="rounded-full border border-[#212638] px-7 py-3.5 font-semibold text-[#F8FAFC] transition-colors hover:bg-[#151824]">View live market</a>
            </div>
            <div className="mt-8 md:hidden"><Ticker /></div>
          </div>
          <div id="market" className="card fade-up p-5 md:p-6 lg:col-span-6" style={{ animationDelay: ".15s" }}>
            <PriceChart compact />
          </div>
        </div>
        <div className="mt-24 grid gap-4 md:grid-cols-3 md:gap-6">
          {FEATURES.map((f, i) => (
            <div key={f.t} className="card fade-up p-6 transition-colors hover:bg-[#1C2030]" style={{ animationDelay: `${0.25 + i * 0.1}s` }}>
              <f.icon className="text-[#F7931A]" size={22} />
              <h3 className="mt-4 text-lg font-semibold tracking-tight">{f.t}</h3>
              <p className="mt-2 text-sm text-[#94A3B8]">{f.d}</p>
            </div>
          ))}
        </div>
        <p className="mt-16 flex items-center gap-2 text-xs text-[#64748B]"><ShieldCheck size={14} /> Payments processed by Stripe. Bitwallet.live never stores your card details.</p>
      </main>
    </div>
  );
}
